/* eslint-disable @typescript-eslint/no-throw-literal */
import { createBrowserRouter } from "react-router-dom";
import RootApplication from "../components/RootApplication";
import { routes } from "./routes";
import { PlatformService } from "../services/PlatformService";

import { LocalStorageService } from "../services/LocalStorageService";
import {
  DEFAULT_TRANSLATION_LANGUAGES,
  LocalStorageLanguageProperty,
} from "../entities/Language";
import { TranslationService } from "../services/TranslationService";
import { SettingService } from "../services/SettingService";
import NotFound from "../pages/NotFound";
import { OPERATIONAL_WEBSHOP_STATUS } from "../entities/Tenant";

export const applicationBrowserRouter = createBrowserRouter([
  {
    element: <RootApplication />,
    children: routes,
    loader: async () => {
      let url = document.referrer ? document.referrer : document.location.href;
      const localeDev = [
        "localhost",
        "dev.dsp5jtfnmvp0r.amplifyapp.com",
        "staging.d3utee1lvc8pno.amplifyapp.com",
      ].some((r) => url.includes(r));
      if (localeDev) {
        url = "https://punegust.websales.ro/";
      }

      const credentials = await PlatformService.platformInit({
        url,
      });

      if (credentials.status === OPERATIONAL_WEBSHOP_STATUS.BLOCKED) {
        throw new Response(
          JSON.stringify({
            message:
              "Webconfigurator not active, please come back later and return to the webshop",
            link: credentials.domain,
          }),
          { status: 400, headers: { 'Content-Type': 'application/json' } },
        );
      }

      if (!credentials.tenantId) {
        throw new Response("Not Found", { status: 404 });
      }
      const settings = await SettingService.getSettingsMix();

      const languageFromLocalStorage = LocalStorageService.getItem(
        LocalStorageLanguageProperty.LANGUAGE,
      );

      let initialLanguage: string = DEFAULT_TRANSLATION_LANGUAGES.US;

      if (credentials?.country?.language?.shortName?.length) {
        initialLanguage =
          credentials?.country?.language?.shortName.toUpperCase();
      }
      if (languageFromLocalStorage) {
        initialLanguage = languageFromLocalStorage.toUpperCase();
      }

      const defaultTranslations = await TranslationService.getTranslations(
        initialLanguage,
      );

      return {
        url,
        credentials,
        settings,
        defaultTranslations,
      };
    },
    errorElement: <NotFound />,
  },
]);
